import {IUser} from '../../../../models';

export const getUserName = (user: IUser) => {
  if (!user) {
    return ''
  }
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`
  }
  if (user.email) {
    return user.email
  }
  return ''
}
